import React from 'react';
import image from '../../../Assets/Cards/androidPhone.webp';
import  imac from '../../../Assets/Icons/android.svg';
import AppPart from '../../Shared/AppPart/AppPart';

const Demo=()=>{
    return(
        <>
        <AppPart 
        title="Turn anything into interactive prototypes"
        desc="Our apps let you create, play and share on the go."
        backgroundImage1 = {imac}
        image={image}
        />
        </>
    )
};
export default Demo ;